import React, { useEffect, useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table";
import {
    DEFAULT_FIRST_PAGE_NUM,
    DEFAULT_PAGE_SIZE,
    defaultMdCmParam
} from "@/utils/constants";
import { ISearchPage } from "@/types/FmsTypes";
import { transPgToPagination } from "../../../../../base/app/appModel";
import { useDetailModel } from "../detailModel";
import { accountService } from "../../../../AccountService";
import { IAccountWriteoffDetail, IAccountWriteoffFields, IAccountWriteoffSearch, IAccountWriteoffSearchParam } from "../../../../AccountTypes";
import { UserTypeEnum } from "@/types/FmsEnums";
import { useGlobalModel } from "@/model/globalModel";

export const useWriteoffModel = createModel(function () {
    const initSearchParam: IAccountWriteoffSearchParam = {};
    const initDataSource: IAccountWriteoffDetail[] = [];
    const initPgCfg: TablePaginationConfig = {
        pageSize: DEFAULT_PAGE_SIZE,
        current: DEFAULT_FIRST_PAGE_NUM
    }
    const { user: { shopCode } } = useGlobalModel();
    //查询条件
    const [searchParam, setSearchParam] = useState<IAccountWriteoffSearchParam>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IAccountWriteoffDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IAccountWriteoffFields>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [openDrawerVisible, setOpenDrawerVisible] = useState(false);
    const [reload, setReload] = useState(false);

    // 核销总额
    const [writeoffAmount, setWriteoffAmount] = useState<number>(0)
    const { customerCode } = useDetailModel();
    const [state, setstate] = useState(false)

    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
        setstate(!state)
    }


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IAccountWriteoffFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setPgCfg(initPgCfg)
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IAccountWriteoffSearchParam = searchParam) => {
        const searchParams: IAccountWriteoffSearch = {
            ...searchValue,
            partnerCode: customerCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER,
            shopCode,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await accountService.writeoffPage(searchParams);
        let { retData: totalRetData } = await accountService.writeoffTotalAmount(searchParams)
        const { records, ...pg } = retData;
        setWriteoffAmount(totalRetData)
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        clearSelectData();
    }


    return {
        /***field***/
        state,
        searchParam,
        reload,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        openDrawerVisible,
        writeoffAmount,
        /***method***/
        setDataSource,
        setReload,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setOpenDrawerVisible,
        onSearch,
        onReset,
        setSelectedData,
        setSearchParam
    }
});
